// https://cascade.org/rides-and-events-free-group-rides/ride-classifications

import Head from 'next/head';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import _map from 'lodash/map';
import { buildTitle } from '../utils/layout';
import config from '../config';
import Main from '../components/main';
import MaterialLinkButton from '../components/material-link-button';
import {
  eventPaces,
  eventTerrains,
  eventDistances,
  eventRegroups,
  eventWeatherCancellations,
} from '../utils/events';

const useStyles = makeStyles((theme) => ({
  addButton: {
    marginTop: theme.spacing(2),
  },
}));

const EventTypes = () => {
  const classes = useStyles();

  return (
    <Main>
      <Head>
        <title>{buildTitle('Event Listing Guide')}</title>
        <link rel="canonical" href={`${config().universal.baseUri}/event-listing-guide`} />
      </Head>

      <Typography variant="h1">Event Listing Guide</Typography>

      <p>
        Everyday Rides is a great place to share your events with the local cycling community.
      </p>

      <Typography variant="h2">Types of Events</Typography>
      <ul>
        <li>Ride</li>
        <li>Event</li>
        <li>Online Event</li>
      </ul>

      <Typography variant="h2">Pace</Typography>
      <ul>
        {_map(eventPaces, ({ name, description }) => (
          <li key={name}>
            {name} ({description})
          </li>
        ))}
      </ul>

      <Typography variant="h2">Distance</Typography>
      <ul>
        {_map(eventDistances, ({ name }) => (
          <li key={name}>
            {name}
          </li>
        ))}
      </ul>

      <Typography variant="h2">Terrain</Typography>
      <ul>
        {_map(eventTerrains, ({ name, description }) => (
          <li key={name}>
            {name} ({description})
          </li>
        ))}
      </ul>

      <Typography variant="h2">Regroup</Typography>
      <ul>
        {_map(eventRegroups, ({ name }) => (
          <li key={name}>
            {name}
          </li>
        ))}
      </ul>

      <Typography variant="h2">Weather Cancellation</Typography>
      <ul>
        {_map(eventWeatherCancellations, ({ name }) => (
          <li key={name}>
            {name}
          </li>
        ))}
      </ul>

{/* What do the different audience types mean?
Briefly, event audience means:

General: most bike rides
Family friendly: distance, content, and pace is appropriate for kids
Adults only (21+): drinking or other adult activities (nudity, etc)
Check out the details in our Code of Conduct for more info. */}

      <MaterialLinkButton
        href="/events/new"
        color="primary"
        variant="contained"
        className={classes.addButton}
      >
        Add Event
      </MaterialLinkButton>
    </Main>
  );
};

export default EventTypes;
